import type { ReactNode } from 'react';
import { useIsMobile } from '../../hooks/useIsMobile';
import DesktopOnlyNotice from './DesktopOnlyNotice';

/**
 * 路由级守卫:移动端渲染「请用电脑端」占位,桌面端渲染真实页面。
 * 在 router 里包裹重研究页(见 router/config.tsx),手机上连重页 chunk 都不必加载。
 */
export default function DesktopOnly({ title, children }: { title?: string; children: ReactNode }) {
  const isMobile = useIsMobile();
  return isMobile ? <DesktopOnlyNotice title={title} /> : <>{children}</>;
}
